import { render, staticRenderFns } from "./RxWidget.vue?vue&type=template&id=061a753c&scoped=true"
import script from "./RxWidget.vue?vue&type=script&lang=js"
export * from "./RxWidget.vue?vue&type=script&lang=js"
import style0 from "./RxWidget.vue?vue&type=style&index=0&id=061a753c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061a753c",
  null
  
)

export default component.exports